var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.09375H2.25C2.02622 3.09375 1.81161 3.18264 1.65338 3.34088C1.49514 3.49911 1.40625 3.71372 1.40625 3.9375V13.5C1.40625 13.873 1.55441 14.2306 1.81813 14.4944C2.08185 14.7581 2.43954 14.9063 2.8125 14.9063H15.1875C15.5605 14.9063 15.9181 14.7581 16.1819 14.4944C16.4456 14.2306 16.5938 13.873 16.5938 13.5V3.9375C16.5938 3.71372 16.5049 3.49911 16.3466 3.34088C16.1884 3.18264 15.9738 3.09375 15.75 3.09375ZM13.5809 4.78125L9 8.98031L4.41914 4.78125H13.5809ZM3.09375 13.2188V5.85563L8.42977 10.7473C8.58539 10.89 8.78886 10.9691 9 10.9691C9.21114 10.9691 9.41461 10.89 9.57023 10.7473L14.9062 5.85563V13.2188H3.09375Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.b6b972de3cdceac9b1d5fb0bbdf10c72.svg";
export { ForwardRef as ReactComponent };